import React, { useEffect } from 'react';
import styles from './Credits.module.css';
import { CustomButton, CustomInputText, CustomLoader, CustomTitle } from '../../../components';
import { useTranslation } from 'react-i18next';
import { getUserInfos } from '../../../services/userService';

const Credits = () => {
    const { t } = useTranslation();

    const [isLoading, setIsLoading] = React.useState<boolean>(true);
    const [credits, setCredits] = React.useState<number>(0);

    useEffect(() => {
        handleCreditsInfos();
    }, []);

    const handleCreditsInfos = async () => {
        setIsLoading(true);

        const userInfos = await getUserInfos();

        setCredits(userInfos.credits);
        setIsLoading(false);
    }

    return (
        <div className={styles.container}>
            { !isLoading &&
                <>
                    <CustomTitle className={styles.title}>{t('account.credits.title')}</CustomTitle>

                    <div className={styles.containerCreditsInfos}>
                        <CustomInputText id="credits" label={t('account.informations.credits')} type="number" textValue={credits} setTextValue={setCredits} disabled />
                        <CustomButton className={styles.addCreditsButton} onClick={() => console.log()}>{t('account.credits.buy_credits')}</CustomButton>
                    </div>
                </>
            }

            <CustomLoader isLoading={isLoading} loaderType='skeleton' />
        </div>
    );
}

export default Credits;